// Регулярное выражение для экранирования ключевых символов в регулярках:
// http://stackoverflow.com/questions/3561493/is-there-a-regexp-escape-function-in-javascript
const regExpEscapeReg = /[-\/\\^$*+?.()|\[\]{}]/g;
/**
 * Экранирует в строке все ключевые символы для создания регулярного выражения на ее основе
 *
 * @param regExpString Входящая строка
 * @returns Строка, подходящая для создания регулярного выражения
 * @example
 * // Экранирование строки с специальными символами
 * const escaped = escapeRegexpString('test.com/path?query=value');
 * // Результат: 'test\\.com/path\\?query=value'
 * const regex = new RegExp(escaped);
 * // Теперь можно безопасно использовать в регулярном выражении
 */
export function escapeRegexpString(regExpString) {
    return regExpString.replace(regExpEscapeReg, '\\$&');
}
